import { apiCall } from '../../../common/api/api'

const baseUrl = `${process.env.GATSBY_API_URL}`

export const getMantenimiento = (): Promise<
  {
    activo: boolean
    fecha_inicio: string
    fecha_fin: string
  }[]
> => {
  return apiCall(`${baseUrl}/mantenimiento`, {
    method: 'GET',
  })
}
